import { DateType } from '../../utils';
import { keepPercentOrLine, keepTwoOrLine, keepTwoOrNull } from '@/utils/utils';

export const getBarChartOption = (data: any[] = [], activeKey: DateType, unit?: string) => {
  return {
    backgroundColor: 'transparent',
    tooltip: {
      formatter: (items: any) => {
        let { axisValue } = items[0];
        let otherStr = '';
        let str = '';
        let allStr = `<div style="margin-top:8px;width:320px;"><div style="display:flex;justify-content:space-between;align-items:center;"><div>总用能</div><div>${keepTwoOrLine(
          items[0]?.data?.[2]
        )}${unit}</div></div>`;
        items.forEach((item: any) => {
          const { seriesName, data, marker } = item;
          const value = keepTwoOrLine(data[1]);

          otherStr += `<div style="margin-top:8px;width:320px;"><div style="display:flex;justify-content:space-between;align-items:center;"><div style="width:100px;"><span>${marker}</span>${seriesName}</div><div>${value}${unit}</div><div>${data[3]}%</div></div>`;
          str = axisValue + allStr + otherStr;
        });

        return str;
      },
    },
    legend: {
      show: true,
      right: 10,
      itemHeight: 8,
      itemWidth: 8,
      data: ['生产时段', '非生产时段'],
      icon: 'rect',
      itemGap: 10,
    },
    grid: {
      left: 20,
      right: 20,
      top: 28,
      bottom: 10,
      containLabel: true,
    },
    xAxis: [
      {
        type: 'category',
        axisLabel: {
          hideOverlap: true,
          showMinLabel: true,
          showMaxLabel: true,
        },
        boundaryGap: true,
      },
    ],
    yAxis: [
      {
        type: 'value',
        name: unit,
      },
    ],
    series: [
      {
        type: 'bar',
        stack: 'total',
        color: '#2D8DFF',
        name: '生产时段',
        barMaxWidth: 20,
        barMinWidth: 4,
        data: data.map(a => {
          return [
            a.time,
            keepTwoOrNull(a.productionPeriodUsage),
            keepTwoOrNull(a.totalUsage),
            keepPercentOrLine(a.productionPeriodPercent),
          ];
        }),
      },
      // 平段电价
      {
        type: 'bar',
        stack: 'total',
        color: '#FFCB47',
        name: '非生产时段',
        barMaxWidth: 20,
        barMinWidth: 4,
        data: data.map(a => {
          return [
            a.time,
            keepTwoOrNull(a.nonProductionPeriodUsage),
            keepTwoOrNull(a.totalUsage),
            keepPercentOrLine(a.nonProductionPeriodPercent),
          ];
        }),
      },
    ],
  };
};
